export const PARTNER_MGMT_CATEGORY_LIST = [
    {
        id: 'none',
        value: 'none',
    },
    {
        id: 'R1',
        value: 'R1',
    },
    {
        id: 'R2',
        value: 'R2',
    },
    {
        id: 'R3',
        value: 'R3',
    },
    {
        id: 'R4',
        value: 'R4',
    },
    {
        id: 'R5',
        value: 'R5',
    },
]

export const CLINIC_REGION_LIST = [
    {
        id: 'East',
        value: 'East',
    },
    {
        id: 'North',
        value: 'North',
    },
    {
        id: 'South',
        value: 'South',
    },
    {
        id: 'West',
        value: 'West',
    },
]

export const CLINIC_PRIORITIZATION_LIST = [
    {
        id: 'A',
        value: 'A',
    },
    {
        id: 'B',
        value: 'B',
    },
    {
        id: 'C',
        value: 'C',
    },
]

export const SCAN_UPLOAD_MODE_LIST = [
    {
        id: 'manual',
        value: 'manual',
    },
    {
        id: '3shape',
        value: '3shape',
    },
]

export const MESSAGE_PLACEHOLDER = '%item%'

export const MANDATORY_FIELDS = [
    {
        id: 'clinicName',
        value: 'Clinic Name',
    },
    {
        id: 'city',
        value: 'City',
    },
    {
        id: 'streetAddress',
        value: 'Address',
    },
    {
        id: 'zip',
        value: 'ZIP',
    },
    {
        id: 'countryCode',
        value: 'Country',
    },
    {
        id: 'email',
        value: 'eMail Address',
    },
    {
        id: 'partnerMgmtCategory',
        value: 'Partner Mgmt. Cat.',
    },
    {
        id: 'scanFileUploadMechanism',
        value: 'Upload Mechanism',
    },
    {
        id: 'technicalName',
        value: 'Technical Name',
    },
    {
        id: 'displayName',
        value: 'Display Name',
    },
    {
        id: 'frontendBookingName',
        value: 'Frontend Booking Name',
    },
    {
        id: 'budgetCityName',
        value: 'Budget City Name',
    },
    {
        id: 'costCenter',
        value: 'Cost Center',
    },
    {
        id: 'googleMapsLink',
        value: 'Google Maps URL',
    },
    {
        id: 'googlePlaceId',
        value: 'Google Place ID',
    },
    {
        id: 'latitude',
        value: 'Latitude',
    },
    {
        id: 'longitude',
        value: 'Longitude',
    },
    {
        id: 'bookingDaysInAdvance3dScan',
        value: 'Booking days in advance 3d Scan',
    },
    {
        id: 'bookingDaysInAdvanceIpr',
        value: 'Booking days in advance IPR',
    },
]



// WEBPACK FOOTER //
// ./src/modules/store/component/form/const.js